import { render, staticRenderFns } from "./CCalendarServicePanel.vue?vue&type=template&id=035b71e6&scoped=true"
import script from "./CCalendarServicePanel.vue?vue&type=script&lang=ts"
export * from "./CCalendarServicePanel.vue?vue&type=script&lang=ts"
import style0 from "./CCalendarServicePanel.vue?vue&type=style&index=0&id=035b71e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035b71e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
